import wixWindowFrontend from 'wix-window-frontend';
import wixApplication from 'wix-application';
import { fetch } from 'wix-fetch';
import wixWindow from 'wix-window';
$w.onReady(function () {
    $w('#marquee').restore()
    $w('#marquee').onViewportEnter(() => {
        wixWindowFrontend.postMessage(Object.assign({
                marquee: $w('#marquee').uniqueId,
                repeater: $w('#repeater1').uniqueId,
                item: $w('#box2').uniqueId
            },
            $widget.props))
    })
    wixApplication.getDecodedAppInstance()
        .then((instance) => {
            if (instance.vendorProductId !== 'premium' && wixWindow.viewMode === 'Site') {
                setTimeout(() => {
                    $w('#marquee').delete()
                }, 30 * 1000)
            }
        })
    fetch("https://certifiedcode.wixsite.com/marquee/_functions/script", {
        headers: {
            "Authorization": wixApplication.getAppInstance()
        }
    })
});